import React, { useState, useEffect } from "react";
import { View, ActivityIndicator } from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import { WebView } from "react-native-webview";
import testIds from "@constants/testIds";
import { isCLApp } from "../config";
import { getToken } from "../services/api";

const WebViewComponent = (props) => {
  const { url, useToken = false } = props;
  const [token, setToken] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const result = await getToken();
        if (result.token) setToken(result.token);
      } catch (err) {
        setToken(null);
      }
    })();
  }, []);

  const uri =
    useToken === "true"
      ? `${url}/?app=${isCLApp ? "cl" : "cx"}&token=${token}`
      : url;

  return useToken === "true" ? (
    token ? (
      <WebView
        source={{ uri }}
        androidHardwareAccelerationDisabled={true}
        style={{ flex: 1, minHeight: 200, height: 300, opacity: 0.99 }}
      />
    ) : (
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <ActivityIndicator />
      </View>
    )
  ) : (
    <WebView testID={testIds.scroll_privacy_page} source={{ uri }} />
  );
};

export default WebViewComponent;
